import React, { Fragment } from "react";
import { array, number, string } from "prop-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import { utilityPropTypes } from "@insightfulscience/atomic-react/props/utility";
import { spacingPropTypes } from "@insightfulscience/atomic-react/props/spacing";
import { sxPropTypes } from "@insightfulscience/atomic-react/props/sx";
import colToRows from "../../../utils/colToRows";
import groupByHeading from "../../../utils/groupByHeading";
import richTextTypes from "../../../richTextTypes/default";

const CopyBlockContent = ({
	id,
	numberOfColumns,
	numberOfBlocks,
	content,
	colUtilityProps,
	colSxProps,
	colSpacingProps,
}) => {
	return (
		<>
			{colToRows(numberOfColumns, groupByHeading(content, numberOfBlocks)).map((column, rowKey) => (
				<Row
					key={`${id}-row-${rowKey}`} // eslint-disable-line react/no-array-index-key
					mx={numberOfColumns !== 1}
					my
				>
					{column.map((items, colKey) => (
						<Col
							key={`${id}-row-${rowKey}-col-${colKey}`} // eslint-disable-line react/no-array-index-key
							md={12 / numberOfColumns}
							spacing={colSpacingProps}
							utility={colUtilityProps}
							sx={colSxProps}
						>
							{items.map((item, key) => (
								<Fragment
									key={`${id}-row-${rowKey}-col-${colKey}-${key}`} // eslint-disable-line react/no-array-index-key
								>
									{documentToReactComponents(item, richTextTypes)}
								</Fragment>
							))}
						</Col>
					))}
				</Row>
			))}
		</>
	);
};

CopyBlockContent.propTypes = {
	id: string,
	numberOfColumns: number,
	numberOfBlocks: number,
	content: array, // eslint-disable-line react/forbid-prop-types,
	colUtilityProps: utilityPropTypes,
	colSpacingProps: spacingPropTypes,
	colSxProps: sxPropTypes,
};

export default CopyBlockContent;
